document.addEventListener("DOMContentLoaded", function() {
  // Check if the screen width is smaller than 1200px
  if (window.innerWidth < 1200) {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy, video.lazy-footer"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(video) {
          if (video.isIntersecting) {
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                videoSource.src = videoSource.dataset.src;
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            video.target.classList.remove("lazy-footer");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function(lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }

    var video = document.getElementById('myVideo');
    if (video) {
        var sources = video.querySelectorAll('source');
        sources.forEach(function(source) {
            source.setAttribute('src', source.getAttribute('data-src'));
        });
        video.load(); // Załaduj nowe źródła
        video.play(); // Rozpocznij odtwarzanie
    }
  } else {
    // Select lazy videos within .projects__fullwidth.fullwidth
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy:not(.projects__swiper-video video):not(.projects__fullwidth video)"));
    var lazyFooterVideos = [].slice.call(document.querySelectorAll("video.lazy-footer"));

    if ("IntersectionObserver" in window) {
        var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var video = entry.target;
                    var sources = video.querySelectorAll('source');
                    sources.forEach(function(source) {
                        // Set src from data-src only in <source> tag
                        source.setAttribute('src', source.getAttribute('data-src'));
                    });
                    video.load();  // This loads the video once sources are updated
                    video.classList.remove("lazy");

                    // Add spinner to the video container
                    addSpinner(video);

                    // Preload a small portion of the video
                    video.muted = true; // Mute the video during preload
                    video.play(); // Start playing to preload a portion

                    // Pause after the video can play
                    video.addEventListener('canplay', function() {
                        video.pause(); // Pause after preloading
                        video.currentTime = 0; // Reset time to start
                        removeSpinner(video); // Remove spinner when video is ready
                    });

                    lazyVideoObserver.unobserve(video);
                }
            });
        });

        var lazyFooterVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
              if (video.isIntersecting) {
                for (var source in video.target.children) {
                  var videoSource = video.target.children[source];
                  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                    videoSource.src = videoSource.dataset.src;
                  }
                }
      
                video.target.load();
                video.target.classList.remove("lazy");
                video.target.classList.remove("lazy-footer");
                lazyFooterVideoObserver.unobserve(video.target);
              }
            });
        });

        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });

        lazyFooterVideos.forEach(function(lazyFooterVideo) {
            lazyFooterVideoObserver.observe(lazyFooterVideo);
        });
    } else {
        // Fallback for browsers that do not support IntersectionObserver
        lazyVideos.forEach(function(lazyVideo) {
            lazyVideo.load();
            lazyVideo.classList.remove("lazy");
        });
    }

    // Function to handle hover functionality for videos
    function setupVideoHover(video) {
        const sources = video.querySelectorAll('source');
        let videoUrl = '';

        // Look for the first source with a valid data-src attribute
        sources.forEach(source => {
            if (source.getAttribute('data-src')) {
                videoUrl = source.getAttribute('data-src'); // Set the URL
                return; // Stop when the first valid source is found
            }
        });

        if (videoUrl) {
            // Extract the file name from the URL (e.g., "rossmann.webm")
            const videoNameWithExtension = videoUrl.substring(videoUrl.lastIndexOf('/') + 1);
            const videoName = videoNameWithExtension.split('.')[0];
            const placeholderUrl = `https://gpdfilmstudio.com/wp-content/themes/gpd-film-studio/assets/dist/images/${videoName}.jpg`;
            
            // Set the poster image
            video.setAttribute('poster', placeholderUrl);

            // Flag to track if video is being played or paused
            let isPlaying = false;

            // Add event listeners for hover functionality
            video.addEventListener('mouseenter', () => {
                if (!isPlaying) {
                    sources.forEach(source => {
                        // Ensure src is set from data-src in <source> only
                        source.setAttribute('src', source.getAttribute('data-src'));
                    });
                    
                    video.load(); // Load the video with updated sources

                    // Add spinner when loading starts
                    addSpinner(video);

                    // Add an event listener to play the video once it's ready
                    video.addEventListener('canplay', async function onCanPlay() {
                        // Remove the event listener after it's used
                        video.removeEventListener('canplay', onCanPlay);

                        try {
                            await video.play(); // Play the video
                            isPlaying = true; // Mark that the video is playing
                            removeSpinner(video); // Remove spinner when the video is ready
                        } catch (error) {
                            console.error("Video play failed", error);
                        }
                    });
                }
            });

            video.addEventListener('mouseleave', () => {
                if (isPlaying) {
                    video.pause(); // Pause the video
                    video.currentTime = 0; // Reset to the beginning
                    isPlaying = false; // Mark that the video is no longer playing

                    // Use a small delay before clearing the video source
                    setTimeout(() => {
                        if (!isPlaying) {
                            sources.forEach(source => {
                                source.removeAttribute('src'); // Clear the source only in <source>
                            });
                            video.load(); // Reload to reset sources
                        }
                    }, 300); // Adjust the delay if needed
                }
            });
        }
    }

    // Handle videos in .projects__swiper-video
    const swiperVideos = document.querySelectorAll('.projects__swiper-video > video');
    swiperVideos.forEach(setupVideoHover);

    // Handle videos in .projects__fullwidth
    const fullWidthVideos = document.querySelectorAll('.projects__fullwidth > video');
    fullWidthVideos.forEach(setupVideoHover);

    // Function to add a loading spinner to the video container
    function addSpinner(video) {
        const container = video.closest('.projects__swiper-video, .projects__fullwidth');
        if (container) {
            const spinner = document.createElement('div');
            spinner.classList.add('video-loader');
            container.appendChild(spinner);

            // CSS for the spinner
            spinner.style.position = 'absolute';
            spinner.style.top = '50%';
            spinner.style.left = '50%';
            spinner.style.width = '40px';
            spinner.style.height = '40px';
            spinner.style.border = '5px solid rgba(255, 255, 255, 0.3)';
            spinner.style.borderTop = '5px solid #fff';
            spinner.style.borderRadius = '50%';
            spinner.style.animation = 'spin 1s linear infinite';
            spinner.style.transform = 'translate(-50%, -50%)';
            spinner.style.zIndex = '10';

            // Add spinner animation (spin)
            const style = document.createElement('style');
            style.innerHTML = `
                @keyframes spin {
                    0% { transform: translate(-50%, -50%) rotate(0deg); }
                    100% { transform: translate(-50%, -50%) rotate(360deg); }
                }
            `;
            document.head.appendChild(style);
        }
    }

    // Function to remove the loading spinner
    function removeSpinner(video) {
        const container = video.closest('.projects__swiper-video, .projects__fullwidth');
        if (container) {
            const spinner = container.querySelector('.video-loader');
            if (spinner) {
                spinner.remove();
            }
        }
    }
}
});